import { render, staticRenderFns } from "./Delivs.vue?vue&type=template&id=0aa93cac&lang=pug"
import script from "./Delivs.vue?vue&type=script&lang=js"
export * from "./Delivs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports